import { Modal, Select, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { FileType, SecuresTypeVal, SelectVal, SelectRoleVal } from '../types';
import { fileTypeBySelectTitle, getOptions } from './config';
import styles from './index.module.less';
const { Option } = Select;
interface IProps {
  title: String;
  type: FileType;
  callback: (
    item: { securesType: SecuresTypeVal; roleId: SelectVal },
    updateFn: any
  ) => void;
  // maxRoleId: SelectVal;
  defaultShareValue?: SelectVal;
  defaultDownloadValue?: SelectVal;
  shareShowValue?: SelectVal;
  downloadShowValue?: SelectVal;
  isWiki?: boolean;
}

interface PrivateProps {
  removeNode?: () => void;
}

function SecuritySet(props: IProps & PrivateProps) {
  const {
    type,
    title,
    defaultShareValue,
    defaultDownloadValue,
    shareShowValue,
    downloadShowValue,
    callback,
    isWiki = false,
    removeNode,
  } = props;
  const [visible, setVisible] = useState(false);
  const [shareOptions, setShareOpt] = useState<any>([]);
  const [downloadOptions, setDownloadOpt] = useState<any>([]);
  const [selectHeader, setSelectHeader] = useState<any>({});
  useEffect(() => {
    const shareOptions: any[] = getOptions(
      type,
      shareShowValue,
      SecuresTypeVal.Share,
      isWiki
    );
    const downloadOptions: any[] = getOptions(
      type,
      downloadShowValue,
      SecuresTypeVal.Download,
      isWiki
    );
    setShareOpt(shareOptions);
    setDownloadOpt(downloadOptions);
    setSelectHeader(fileTypeBySelectTitle(type));
    setVisible(true);
  }, [type, title, shareShowValue, downloadShowValue]);
  return (
    <Modal
      className={styles['security-setting-modal']}
      title={title}
      visible={visible}
      footer={null}
      onCancel={() => {
        setVisible(false);
        removeNode?.();
      }}
    >
      <div className={styles['security-setting-main']}>
        <h3 className={styles['security-setting-main-title']}>
          {selectHeader.shareTitle}
        </h3>
        <Select
          className={styles['security-setting-main-select']}
          size="large"
          defaultValue={defaultShareValue || shareOptions[0]?.value}
          // options={shareOptions}
          onChange={val => {
            // setVisible(false);
            const item = shareOptions.find((item: any) => item.value === val);
            callback?.(
              {
                securesType: SecuresTypeVal.Share,
                roleId: item?.roleId ?? SelectRoleVal.FileAll,
              },
              setShareOpt
            );
            // removeNode?.();
          }}
        >
          {shareOptions?.map((item: any, index: number) => {
            return (
              <Option key={index} value={item.value} disabled={item.disabled}>
                {item.disabled ? (
                  <Tooltip placement="left" title={item.tips}>
                    <a style={{ cursor: 'not-allowed' }}>
                      <h4
                        className={styles['security-setting-main-select_name']}
                      >
                        {item.lebal}
                      </h4>
                      <p
                        className={styles['security-setting-main-select_desc']}
                      >
                        {item.desc}
                      </p>
                    </a>
                  </Tooltip>
                ) : (
                  <a>
                    <h4 className={styles['security-setting-main-select_name']}>
                      {item.lebal}
                    </h4>
                    <p className={styles['security-setting-main-select_desc']}>
                      {item.desc}
                    </p>
                  </a>
                )}
              </Option>
            );
          })}
        </Select>
        <h3
          className={[
            styles['security-setting-main-title'],
            styles['security-setting-main-download-title'],
          ].join(' ')}
        >
          {selectHeader.downloadTitle}
        </h3>
        <Select
          className={styles['security-setting-main-select']}
          size="large"
          defaultValue={defaultDownloadValue || downloadOptions[0]?.value}
          // options={downloadOptions}
          onChange={val => {
            const item = downloadOptions.find(
              (item: any) => item.value === val
            );
            callback?.(
              {
                securesType: SecuresTypeVal.Download,
                roleId: item?.roleId ?? SelectRoleVal.FolderAll,
              },
              setDownloadOpt
            );
            // removeNode?.();
          }}
        >
          {downloadOptions?.map((item: any, index: number) => {
            return (
              <Option key={index} value={item.value} disabled={item.disabled}>
                {item.disabled ? (
                  <Tooltip placement="topLeft" title={item.tips}>
                    <a style={{ cursor: 'not-allowed' }}>
                      <h4
                        className={styles['security-setting-main-select_name']}
                      >
                        {item.lebal}
                      </h4>
                      <p
                        className={styles['security-setting-main-select_desc']}
                      >
                        {item.desc}
                      </p>
                    </a>
                  </Tooltip>
                ) : (
                  <a>
                    <h4 className={styles['security-setting-main-select_name']}>
                      {item.lebal}
                    </h4>
                    <p className={styles['security-setting-main-select_desc']}>
                      {item.desc}
                    </p>
                  </a>
                )}
              </Option>
            );
          })}
        </Select>
      </div>
    </Modal>
  );
}

export default function securitySetModal(props: IProps) {
  const ele = document.createElement('div');
  document.body.appendChild(ele);
  function removeNode() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<SecuritySet {...{ ...props, removeNode }} />, ele);
}
